import React, { useState } from 'react';

/**
 * Text input that shows comma-separated + 2-decimal formatted value when blurred,
 * and raw editable value when focused. Use in place of type="number" for money fields.
 */
export default function MoneyInput({ value, onChange, ...props }) {
  const [focused, setFocused] = useState(false);

  const formatted = () => {
    if (value === '' || value === null || value === undefined) return '';
    const n = parseFloat(value);
    if (isNaN(n)) return value;
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  };

  return (
    <input
      {...props}
      type="text"
      inputMode="decimal"
      value={focused ? (value ?? '') : formatted()}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        // Strip thousands separators; allow digits, dot, minus
        const clean = e.target.value.replace(/[^0-9.\-]/g, '');
        onChange({ ...e, target: { ...e.target, value: clean } });
      }}
    />
  );
}
